<template>
    <div>
        <Header/>
        <div ref="content">
            
            <Swipe :banners="bannerList"/>
            <BannerDown :recommendList="recommendList"/>
            <IfmNews :newsObj="newsObj"/>
            
            <AfterZixun2/>
            <Ifmgrade/>
            <img :src="globalObj.index_ads_banner.image" style="width:100%;height:205px">
            <IfmActivity :activityList="activityList"/>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Swipe from './components/swipe';
import BannerDown from './components/bannerDown.vue';
import IfmNews from './components/ifmNews.vue';
import Ifmgrade from './components/ifmgrade.vue';
import IfmActivity from './components/ifmActivity.vue';
import AfterZixun2 from './components/afterZixun2.vue';

export default {
    computed: mapState([
        'globalObj'
    ]),
    components:{
        Swipe,
        BannerDown,
        IfmNews,
        Ifmgrade,
        IfmActivity,
        AfterZixun2
    },
    data() {
        return {
            bannerList:[],
            newsObj:{},
            recommendList:[],
            activityList:[],
        }
    },
    mounted(){
        this.getBanners();
        this.getRecommend();
        this.getNews();
        this.getActivityList();
    },
    methods: {
        async getBanners(){
            try {
                const res = await this.$http.get('/api/index/getBannerList');
                res.length&&(this.bannerList = res);
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
            
        },
        async getRecommend(){
            const res = await this.$http.get('/api/index/getNewsList',{is_recommend:1});
            this.recommendList = res.list;
            console.log(this.recommendList, 'this.recommendList');
        },
        async getNews(){
            const res = await this.$http.get('/api/index/getNewsList',{is_index:1});
            this.newsObj = res;
        },
        async getActivityList(){
            const res = await this.$http.get('/api/index/getActivityList',{is_index:1});
            res.length&&(this.activityList = res);
        },
    },
}
</script>
<style lang="scss" scoped>
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}

</style>
